import React from "react";
import { StoreProvider } from "./store/store.context";
import { BrowserRouter } from "react-router-dom";
import "./styles/App.css";
import AppRoutes from "./config/app-routes";

const App = () => (
  <BrowserRouter>
    <StoreProvider>
      <AppRoutes />
    </StoreProvider>
  </BrowserRouter>
);

export default App;
